"use client"
import { ChevronDown } from "lucide-react";
import Link from "next/link";
import MenuBlog from "./components/MenuBlog";

const LinkBlog = () => {
  return (
    <div className="group">
      <Link
        className="text-sm flex items-center text-text group-hover:text-pink group-hover:font-bold"
        href={"/blog"}
      >
        مقالات
        <ChevronDown className="size-4 ml-1" />
      </Link>
      <MenuBlog />
    </div>
  );
};

export default LinkBlog;